import React, {useCallback, useEffect} from 'react';

import Checkbox from '../../../elements/forms/Checkbox';
import CheckboxQuestion from './CheckboxQuestion';
import checkCondition from '../common/checkCondition';

const OptionsQuestion = props => {
    const {event, question, options, value, questions, formAnswer, onChange} = props,
        filteredOptions = options.filter(option => !option.enable_condition || checkCondition(formAnswer, option.enable_condition));

    // Unselect already selected options if the other answers change
    useEffect(() => {
        let value = _(props.value || [])
            .reject(value => !_(options).find(option => option.value == value))
            .value();
        if (value.length != props.value?.length) {
            onChange(value);
        }
    }, [value, options]);

    const handleToggleOption = useCallback(
        (option, checked) => {
            if (checked) {
                if (question.max_options == 1) {
                    onChange([option.value]);
                } else {
                    onChange(
                        _([...(value || []), option.value])
                            .uniq()
                            .value()
                    );
                }
            } else {
                onChange(
                    _(value || [])
                        .reject(value => value == option.value)
                        .value()
                );
            }
        },
        [value, question, onChange]
    );

    // console.log(options, filteredOptions);

    if (filteredOptions.length == 1) {
        return <CheckboxQuestion {...props} />;
    } else {
        return (
            <div className="EventForm--OptionsQuestion">
                {question.label ? <h5>{question.label}</h5> : null}
                {filteredOptions.length ? (
                    filteredOptions.map((option, i) => {
                        return (
                            <div className="option" key={i}>
                                <Checkbox
                                    color={event.settings.primary_color}
                                    checked={value.find(v => v == option.value)}
                                    onChange={checked => handleToggleOption(option, checked)}>
                                    <p className="text main">{option.label}</p>
                                    <p className="text">{option.label_line_2}</p>
                                </Checkbox>
                            </div>
                        );
                    })
                ) : question.min_options > 0 ? (
                    <div className="text main content text-center">
                        No options available
                        <br />
                        Please check the input you gave to&nbsp;
                        <strong>
                            {_(options)
                                .chain()
                                .map(option => option.enable_condition)
                                .flatten()
                                .compact()
                                .map(condition => condition.formquestion_id)
                                .uniq()
                                .map(id => _(questions).find(question => question.id == id))
                                .compact()
                                .map(question => question.label)
                                .value()
                                .join()}
                        </strong>
                        <br />
                        <br />
                    </div>
                ) : null}
            </div>
        );
    }
};

export default class OptionsFetcher extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            options: props.question.retrieve_online ? [] : props.question.options,
            loaded: !props.question.retrieve_online,
        };
    }
    componentDidMount() {
        if (this.props.question.retrieve_online) {
            console.log(this.props.formAnswer);
            let answers = _(this.props.question)
                .chain()
                .get('depends_on', [])
                .map(questionId => {
                    return _(this.props.formAnswer)
                        .chain()
                        .get(questionId, [])
                        .map(value => ({formquestion_id: questionId, value}))
                        .value();
                })
                .flatten()
                .value();
            app.store.dispatch(app.actions.ui.busy());
            app.api.forms
                .fetchConditionalOptions(this.props.question.id, answers)
                .then(data => {
                    this.setState({
                        options: data.map(option => ({
                            ...option,
                            enable_condition: JSON.parse(option.enable_condition),
                        })),
                        loaded: true,
                    });
                })
                .catch(err => console.error(err))
                .then(() => {
                    app.store.dispatch(app.actions.ui.free());
                });
        }
    }
    render() {
        if (this.state.loaded) {
            console.log(this.state.options);
            return <OptionsQuestion {...this.props} options={this.state.options} />;
        }
        return null;
    }
}
